// ======================================================================
// File Name       : importList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { RETURN_MAX_NUM } from '../../constants';

export function postEditListGetResult(data, pathOptions) {
  const PARAM_DEFAULT = {
    returnMaxNum: RETURN_MAX_NUM,
  };

  return commonCallApi({
    path: pathOptions.getListPath,
    data: { ...PARAM_DEFAULT, ...data },
    drillServer: pathOptions.getListDrillServer,
    enterpriseId: pathOptions.enterpriseId,
  });
}

export function postEditList(data, options, pathOptions) {
  return commonCallApi({
    ...options,
    path: pathOptions.importPath,
    data,
    muiltipart: 1,
    drillServer: pathOptions.importDrillServer,
    enterpriseId: pathOptions.enterpriseId,
  });
}
